import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatNativeDateModule } from '@angular/material/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CookieService } from 'ngx-cookie-service';
import { CommonModule, DatePipe } from '@angular/common';
import { UnsubscribeService } from '@libs/shared/services/unsubscribe.service';
import { HttpErrorInterceptor } from '@libs/interceptors/http-error-interceptor';
import { TokenInterceptor } from '@libs/interceptors/token.interceptor';
import { UrlService } from '@libs/services/url.service';
import { CardService } from '@libs/services/card.service';
import { LoanService } from '@libs/services/loan.service';
import { ClientService } from '@libs/services/client.service';
import { ClientStore } from '@libs/shared/storage/client.store';
import { LastApplicationStorage } from '@libs/shared/storage/last-application.storage';
import { ProductStore } from '@libs/shared/storage/product.store';
import { UserVerificationService } from '@libs/services/user-verification.service';
import { ProductService } from '@libs/services/product.service';
import { DocumentService } from '@libs/services/document.service';
import { GuidService } from '@libs/shared/services/guid.service';
import { PrivateModeService } from '@libs/shared/services/private-mode.service';
import { AffiliateService } from '@libs/shared/services/affiliate.service';
import { LoansStorage } from '@libs/shared/storage/loans.storage';
import { FormExecutorService } from '@libs/services/form-executor.service';
import { ScannerService } from '@libs/services/scanner.service';
import { BankIdService } from '@libs/services/bank-id.service';
import { SharedModule } from '@libs/shared/shared.module';
import { HeaderModule } from '@libs/shared/components/header/header.module';
import { FooterModule } from '@libs/shared/components/footer/footer.module';
import { CalculateStore } from '@libs/shared/storage/calculate.store';
import { GlobalErrorHandler } from '@libs/interceptors/global-error-handler';
import { LoanHistoryStorage } from '@libs/shared/storage/loan-history.storage';
import { ToasterWidgetModule } from '@libs/shared/components/toaster-widget/toaster-widget.module';
import { LOAN_NOTICE_TOKEN, NOTICE_SUNCREDIT } from '@libs/shared/components/loan-notice/notice-config';
import { SendEventHelper } from '@libs/helpers/send-event.helper';
import { RecaptchaHelper } from '@libs/helpers/recaptcha.helper';
import { MOCK_PRODUCT_TOKEN, SUNCREDIT } from '@libs/configs/calculate.token';

const PROVIDERS = [
  { provide: LOAN_NOTICE_TOKEN, useValue: NOTICE_SUNCREDIT },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  { provide: MOCK_PRODUCT_TOKEN, useValue: SUNCREDIT },
];

const STORAGES = [ClientStore, LastApplicationStorage, ProductStore, LoansStorage, CalculateStore, LoanHistoryStorage];

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    SharedModule,
    ToasterWidgetModule,
  ],
  providers: [
    ...PROVIDERS,
    ...STORAGES,
    UrlService,
    CardService,
    LoanService,
    ClientService,
    UserVerificationService,
    ProductService,
    ScannerService,
    BankIdService,
    CookieService,
    DocumentService,
    GuidService,
    PrivateModeService,
    AffiliateService,
    DatePipe,
    UnsubscribeService,
    FormExecutorService,
    SendEventHelper,
    RecaptchaHelper,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
